import { useLayoutElementsResponse } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/useLayoutElementsResponse";

export const useLayoutElementsLoading = (): boolean => {
  const { isFetching, data } = useLayoutElementsResponse();

  return isFetching || data === undefined;
};

export const useLayoutElementsDataUpdatedAt = (): number => {
  const { dataUpdatedAt } = useLayoutElementsResponse();
  return dataUpdatedAt;
};
